<!--title -->
<app-modal-title
  [title]="'common.uploadFile' | translate"
  [isShowClose]="true"
  (isCloseModal)="onClose()"
></app-modal-title>

<div mat-dialog-content class="dialog-content">
  <form
    [formGroup]="form"
    autocomplete="off"
    enctype="multipart/form-data"
    (ngSubmit)="onSubmit()"
  >
    <section>
      <!-- file-uploader -->
      <div class="tw-flex-center flex-column">
        <div class="tw-w-full">
          <div class="image-upload">
            <file-uploader
              [label]="fields + 'file'"
              [control]="form?.get('file')"
              class="tw-w-[275px]"
              (valueChange)="getFile($event)"
              [acceptFile]="acceptedFileTypes"
              [maxFileSize]="10"
              sizeType="mb"
              (onErrorFile)="showErrorDialog($event)"
            >
            </file-uploader>
          </div>
        </div>

        <!-- helpFileType -->
        <div class="tw-w-full">
          <enum-select-search
            class="tw-w-full"
            enumName="HelpFileTypes"
            [label]="fields + 'helpFileType' | translate"
            [control]="form?.get('helpFileType')"
            [(value)]="helpFileType"
            (valueChange)="getAcceptedFiles($event)"
            (onError)="onClose()"
          >
          </enum-select-search>
        </div>
      </div>
    </section>

    <app-form-btns
      [loading]="loading"
      [form]="form"
      [isEdit]="false"
      (onClose)="onClose()"
      (onSubmit)="onSubmit()"
    >
    </app-form-btns>
  </form>
</div>
